<template>
  <div
    v-if="items.length"
    class="confirmation active"
    :class="{
      'confirmation--centered': centered == true
    }"
  >
    <div class="confirmation__overlay" />
    <div class="confirmation__box">
      <div class="confirmation__box__text">
        <div class="d-flex align-items-center">
          <!--div class="atom-icon mr-0">
            <img src="@/assets/icons/actions/ico-ico-delete-red.svg">
          </div-->
          <h4 class="font-weight-bolder mb-3">
            {{ $t("necoSeNepovedlo") }}
          </h4>
        </div>
        <ul class="">
          <li
            v-for="(item, index) in items"
            :key="index"
            class="text-left gray-text-light mb-0 text-small"
          >
            <p class="mb-0">
              {{ item }}
            </p>
          </li>
        </ul>
      </div>
      <div
        class="confirmation__box__buttons d-flex align-items-center justify-content-end"
      >
        <button class="btn btn-primary" @click="close()">
          {{ $t("ok") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
//import _ from "lodash";
import axios from "axios";
export default {
  props: {
    errors: {
      type: Array,
      default: () => []
    },
    opened: Boolean,
    //items: Array,
    centered: Boolean
  },
  data() {
    return {
      items: []
    };
  },
  computed: {},
  watch: {
    opened: {
      imidiate: true,
      handler() {
        if (this.opened) {
          this.items = [];
          this.translateErrors();
        }
      }
    }
  },
  mounted() {
    this.translateErrors();
  },
  methods: {
    close() {
      this.items = [];
      this.$emit("close");
    },
    translateErrors() {
      this.items = [];

      //console.log("translatedErrors");
      //console.log(this.errors);

      if (this.errors.length > 0) {
        this.errors.forEach(error => {
          console.log("loop_translate_errors");

          if (error.errors[0].message && !error.errors[0].attribute) {
            console.log("cond 1");
            error.errors.forEach(err1 => {
              axios
                .post(process.env.VUE_APP_APICMS + "/translate", err1)
                .then(result => {
                  result.data.forEach(err => {
                    if (!this.items.includes(err)) {
                      this.items.push(err);
                    }
                  });
                })
                .catch(() => {
                  error.errors.forEach(err => {
                    let translate = this.$t(err.message);
                    if (!this.items.includes(translate)) {
                      this.items.push(translate);
                    }
                  });
                });
            });
          } else if (error.errors.length) {
            console.log("cond 2");
            axios
              .post(process.env.VUE_APP_APICMS + "/translate", error.errors)
              .then(result => {
                result.data.forEach(err => {
                  console.log("err", err);
                  if (!this.items.includes(err)) {
                    this.items.push(err);
                  }
                });
              })
              .catch(() => {
                error.errors.forEach(err => {
                  console.log("catch err", err);
                  let translate = this.$t(err);
                  if (!this.items.includes(translate)) {
                    this.items.push(translate);
                  }
                });
              });
          } else {
            console.log("cond 3");
            axios
              .post(process.env.VUE_APP_APICMS + "/translate", error)
              .then(result => {
                result.data.forEach(err => {
                  if (!this.items.includes(err)) {
                    this.items.push(err);
                  }
                });
              })
              .catch(() => {
                error.errors.forEach(err => {
                  let translate = this.$t(err);
                  if (!this.items.includes(translate)) {
                    this.items.push(translate);
                  }
                });
              });
          }
        });
      }

      this.items = [...new Set(this.items)];
    }
  }
};
</script>

<style lang="scss" scoped></style>
